import React from "react";
import { Layout } from "@sicredi/react";
import "./styles.scss";

export const Wrapper: React.FC<{ className?: string }> = ({
  className,
  children,
}) => {
  return (
    <Layout.Wrapper className={`wrapper ${className ?? ""}`}>
      {children}
    </Layout.Wrapper>
  );
};

export default Wrapper;
